import React, { useEffect, useState, useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useAuth } from "../../components/Context/AuthContext";
import Login from "../LogIn/Login";
import Signup from "../SignUp/Signup";
import { Chat, Token } from "@mui/icons-material";
import Transcription from "../Transcription/Transcription";
import { Link, Navigate, useNavigate } from "react-router-dom";
import API_URL from "../../config";
import axios from "axios";
import FileUpload from "../../components/FileUpload/FileUpload";
import { Card, CardContent, IconButton, Container } from "@mui/material";
import { motion } from "framer-motion";
import Transcribe from "../../assets/Transcribe.png";
import ChatIcon from "../../assets/Chat.png";
import Other from "../../assets/Other.png";
import API_BASE_URL from "../../utils/api";

const HubResources = () => {
  const { user } = useAuth();

  const [showFirstTimeWelcome, setShowFirstTimeWelcome] = useState(false);
  const [showFirstGrantCongrats, setShowFirstGrantCongrats] = useState(false);

  useEffect(() => {
    if (!user || !user._id) return;

    const welcomeKey = `welcome_seen_${user._id}`;
    if (!localStorage.getItem(welcomeKey)) {
      setShowFirstTimeWelcome(true);
      localStorage.setItem(welcomeKey, "1");
    }

    if (user.grantsAccess) {
      const grantKey = `grant_welcome_seen_${user._id}`;
      if (!localStorage.getItem(grantKey)) {
        setShowFirstGrantCongrats(true);
        localStorage.setItem(grantKey, "1");
      }
    }
  }, [user]);
  const [showSignup, setShowSignup] = useState(false);
  const [categories, setCategories] = useState([]);
  const [documents, setDocuments] = useState(null);
  const [hoveredChatThread, setHoveredChatThread] = useState(false);
  const [hoveredOtherResources, setHoveredOtherResources] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      axios
        .get(`${API_BASE_URL}/documents`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        .then((res) => {
          const groupedDocuments = res.data.reduce((acc, doc) => {
            acc[doc.category] = acc[doc.category] || [];
            acc[doc.category].push(doc);
            return acc;
          }, {});
          setCategories(Object.entries(groupedDocuments));
        })
        .catch((err) => console.error("Error fetching documents:", err));
    }
  }, [user]);

  useEffect(() => {
    document.title = "Join Our Community Initiatives - MS Digital Hub";
  }, []);

  return (
    <Box
      sx={{
        width: "auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          maxWidth: 800,
          mx: "auto",
          mb: 4,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 1,
            textAlign: "center",

            paddingBottom: "5px",
          }}
        >
          {!user
            ? "Join our community initiatives"
            : `Welcome, ${user.name || "there"}!`}
        </Typography>
        {user && (
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              lineHeight: 1.6,
            }}
          >
            Thank you for joining our community initiatives. We're excited to
            have you here!
          </Typography>
        )}
        {user?.grantsAccess && (
          <Typography
            variant="body2"
            sx={{
              mt: 1.5,
              color: showFirstGrantCongrats ? "success.main" : "text.secondary",
              fontWeight: showFirstGrantCongrats ? 600 : 400,
              lineHeight: 1.6,
            }}
          >
            {showFirstGrantCongrats ? (
              <>
                🎉 Congratulations on receiving your grant! This is where you
                can access your <a href="/grants-dashboard">Grants Dashboard</a>{" "}
                to track digitized documents and upload your receipts.
              </>
            ) : (
              <>
                As a grantee, you can manage your digitization progress and
                upload receipts anytime from your{" "}
                <a href="/grants-dashboard">Grants Dashboard</a>.
              </>
            )}
          </Typography>
        )}
      </Box>

      <Typography
        variant="body1"
        sx={{ marginBottom: "30px", lineHeight: "1.8", textAlign: "justify" }}
      >
        The Mississippi Digital Humanities Hub seeks to facilitate digitization
        and digital humanities projects in Mississippi. To assist you, we
        developed a transcription tool, an asynchronous chat room, and other
        tools. Feel free to explore our transcription tool and asynchronous chat
        room. (And don't worry, although we will use your email to send
        occasional updates about available resources, we will not share these
        emails with any other entity.)
      </Typography>

      <Typography
        variant="body1"
        sx={{ marginBottom: "30px", lineHeight: "1.8", textAlign: "justify" }}
      >
        We are able to make these resources available due to a generous federal
        grant administered by the National Historic Publications and Records
        Commission.
      </Typography>

      {user ? (
        <Box>
          {user?.role === "admin" && <FileUpload />}

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                md: "1fr 1fr 1fr",
              },
              gap: 3,
              marginBottom: "30px",
              marginTop: "30px",

              alignItems: "center",
            }}
          >
            <Card
              sx={{
                p: 2,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: "center",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: "#fffbe7",
                },
                position: "relative",
              }}
              onClick={() => navigate(`/transcription`)}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  bgcolor: "#FFD700",
                  color: "#000",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "4px",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Beta
              </Box>
              <CardContent>
                <IconButton
                  sx={{
                    borderRadius: 0,
                    padding: 0,
                    background: "transparent",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={Transcribe}
                    alt="Custom Icon"
                    sx={{
                      width: 80,
                      height: 80,
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.1)",
                      },
                    }}
                  />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 2,
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <br />
                  Transcribing Manuscripts
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                p: 2,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: "center",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: "#fffbe7",
                },
                position: "relative",
              }}
              onClick={() => navigate(`/Chat-Thread`)}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  bgcolor: "#FFD700",
                  color: "#000",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "4px",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Beta
              </Box>
              <CardContent
                sx={{
                  filter: hoveredChatThread ? "blur(4px)" : "none",
                  transition: "filter 0.3s ease-in-out",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <IconButton
                  sx={{
                    borderRadius: 0,
                    padding: 0,
                    background: "transparent",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={ChatIcon}
                    alt="Custom Icon"
                    sx={{
                      width: 80,
                      height: 80,
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.1)",
                      },
                    }}
                  />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 2,
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <br />
                  Chat Thread
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                position: "relative",
                p: 2,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: "center",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: "#fffbe7",
                },
              }}
              onMouseEnter={() => setHoveredOtherResources(true)}
              onMouseLeave={() => setHoveredOtherResources(false)}
            >
              {hoveredOtherResources && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "20px",
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.6rem",

                    borderRadius: "5px",
                  }}
                >
                  Coming soon
                </Box>
              )}
              <CardContent
                sx={{
                  filter: hoveredOtherResources ? "blur(4px)" : "none",
                  transition: "filter 0.3s ease-in-out",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <IconButton
                  sx={{
                    borderRadius: 0,
                    padding: 0,
                    background: "transparent",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={Other}
                    alt="Custom Icon"
                    sx={{
                      width: 80,
                      height: 80,
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.1)",
                      },
                    }}
                  />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 2,
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <br />
                  Other Resources
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Box>
      ) : (
        <Box>
          <Signup />
        </Box>
      )}
    </Box>
  );
};

export default HubResources;
